import apiClient from './authService';

// Serviços para Materiais Utilizados no Atendimento
export const getMateriaisUtilizados = async (scheduleId, appointmentId) => {
  const response = await apiClient.get(`/api/v1/schedules/${scheduleId}/appointments/${appointmentId}/materiais/`);
  return response.data;
};

export const adicionarMaterialUtilizado = async (scheduleId, appointmentId, materialData) => {
  const response = await apiClient.post(`/api/v1/schedules/${scheduleId}/appointments/${appointmentId}/materiais/`, materialData);
  return response.data;
};

export const atualizarMaterialUtilizado = async (scheduleId, appointmentId, materialId, materialData) => {
  const response = await apiClient.put(`/api/v1/schedules/${scheduleId}/appointments/${appointmentId}/materiais/${materialId}/`, materialData);
  return response.data;
};

export const removerMaterialUtilizado = async (scheduleId, appointmentId, materialId) => {
  const response = await apiClient.delete(`/api/v1/schedules/${scheduleId}/appointments/${appointmentId}/materiais/${materialId}/`);
  return response.data;
};

export const getMateriaisEstoqueDisponiveis = async (scheduleId, appointmentId) => {
  const response = await apiClient.get(`/api/v1/schedules/${scheduleId}/appointments/${appointmentId}/materiais/estoque/`);
  return response.data;
};

// Serviços para Atendimento
export const marcarPacienteAtendido = async (scheduleId, appointmentId, atendimentoData) => {
  const response = await apiClient.post(`/api/v1/schedules/${scheduleId}/appointments/${appointmentId}/attend`, atendimentoData);
  return response.data;
};

export const getAgendamento = async (scheduleId, appointmentId) => {
  const response = await apiClient.get(`/api/v1/schedules/${scheduleId}/appointments/${appointmentId}/`);
  return response.data;
}; 